import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid, TextField } from '@mui/material'

const IPCConsiderations = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <TextField
        label="IPC Considerations"
        multiline
        minRows={2}
        value={medPlan?.ipcConsiderations}
        fullWidth
        InputLabelProps={{
          shrink: !!medPlan?.ipcConsiderations,
        }}
        onChange={(e) => {
          setMedPlan((prev) => ({
            ...prev,
            ipcConsiderations: e.target.value,
          }))
          !changesPresent && setChangesPresent(true)
        }}
      />
    </Grid>
  )
}

export default React.memo(IPCConsiderations)
